import React from "react";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";
import { apiProviders, runningRelease } from "../../variables/app";

function TargetPlatformFilter(props) {
  const { classes } = props;

  const targetPlatforms = [
    {
      value: "0",
      label: "All platform targets",
    },
    ...runningRelease,
  ];

  return (
    <Select
      MenuProps={{
        className: classes.selectMenu,
      }}
      classes={{
        select: classes.select,
      }}
      inputProps={{
        name: "simpleSelect",
        id: "simple-select",
        style: { paddingTop: "32px" },
      }}
      onChange={(e) => {
        let value = e.target.value;

        switch (value) {
          case "0":
            props.setFilter("targetPlatform", null);
            break;
          default:
            props.setFilter("targetPlatform", { field: "targetPlatform", operator: "=", value: value });
            break;
        }
      }}
      style={{ backgroundColor: props.targetPlatform?.value && props.targetPlatform?.value != "0" ? "#ff9800" : null }}
      value={props.targetPlatform?.value ? props.targetPlatform.value : props.targetPlatform == null ? "0" : "NULL"}
    >
      {targetPlatforms.map((item) => (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={item.value}
          value={item.value}
        >
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}

const mapStateToProps = (state) => ({
  ["targetPlatform"]: state.filtersV2["targetPlatform"],
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TargetPlatformFilter, productenStyle));
